import { takeEvery, put } from 'redux-saga/effects';

import { GET_TRANSLATION_FILE } from 'actions/documentMeta/types';
import { fetchTranslationAction } from 'actions/documentMeta';
import lang from 'constants/translation.json';

export function* getTranslationFile() {
  yield put(fetchTranslationAction(lang));
  // try {
  //   const apiUrl: string = '/translation.json';
  //   const response = yield call(fetch, apiUrl);
  //   const lang = yield response.json();
  //   yield put(fetchTranslationAction(lang));
  // } catch (e) {
  //   yield put(
  //     fetchTranslationFileErrorAction(
  //       e.response.data?.message,
  //       e.response.status
  //     )
  //   );
  // }
}

export default function* watchGetTranslationFile() {
  yield takeEvery(GET_TRANSLATION_FILE, getTranslationFile);
}
